<div class="row justify-content-center">
    <div class="col-lg-8">
        <div class="card">
            <div class="card-header bg-info">
                <h4 class="m-b-0 text-white">Factores Barsit</h4>
            </div>
            <div class="card-body">
                <form [formGroup]="barsicFactorForm" (ngSubmit)="register()">
                    <div class="form-body">
                        <h3 class="card-title">Crear / actualizar factor</h3>
                        <hr>
                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Deficiente - Inferior</label>
                                    <input formControlName="veryLowDesc" type="text"  class="form-control" placeholder="Deficiente - Inferior">
                                </div>
                            </div>

                        </div>
                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Medio medio</label>
                                    <input formControlName="lowDesc" type="text"  class="form-control" placeholder="Medio medio">
                                </div>
                            </div>

                        </div>
                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Medio superior</label>
                                    <input formControlName="midDesc" type="text"  class="form-control" placeholder="Medio Superior">
                                </div>
                            </div>

                        </div>
                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Superior</label>
                                    <input formControlName="highDesc" type="text"  class="form-control" placeholder="Superior">
                                </div>
                            </div>

                        </div>
                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Excelente</label>
                                    <input formControlName="veryHighDesc" type="text"  class="form-control" placeholder="Excelente">
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Factor</label>
                                    <select formControlName="name" class="form-control custom-select">
                                        <option selected value="informacion">Información</option>
                                        <option value="razonamientoVerbal">Razonamiento verbal</option>
                                        <option value="comprensionDeVocabulario">Comprensión de vocabulario</option>
                                        <option value="razonamientoLogico">Razonamiento lógico</option>
                                        <option value="razonamientoNumerico">Razonamiento Numerico</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="form-actions">
                        <button type="submit" class="btn btn-success"> <i class="fa fa-check"></i> Crear</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<div class="card p-20">
    <h4>Rangos</h4>
    <div class="row form-material">
        <div class="col-md-4 ">
            <div class="form-group">
                <label class="control-label">Factor</label>
                <select [(ngModel)]="selectedValue" class="form-control custom-select">
                    <option value="Deficiente Inferior">Deficiente Inferior</option>
                    <option value="Medio Medio">Medio Medio</option>
                    <option value="Medio Superior">Medio Superior</option>
                    <option value="Superior">Superior</option>
                    <option value="Excelente">Excelente</option>
                </select>
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label class="control-label">Intervalo inferior</label>

                <input type="number" [(ngModel)]="ranks.low" class="form-control" placeholder="Intervalo inferior">
            </div>
        </div>
        <div class="col-md-4">

            <div class="form-group">
                <label class="control-label">Intervalo superior</label>

                <input type="number" [(ngModel)]="ranks.high" class="form-control" placeholder="Intervalo superior">
            </div>
        </div>
    </div>
    <div>
        <button type="button" (click)="addRank()" class="btn btn-success waves-effect pull-right">Agregar/Reemplazar</button>
    </div>

</div>

<div class="col-12">
    <div class="card">
        <div class="card-body">
            <h4 class="card-title">Rangos declarados</h4>
            <div class="table-responsive">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Calificación</th>
                            <th>Bajo</th>
                            <th>Alto</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Deficiente Inferior</td>
                            <td>{{barsicRanksForm.get('vlowl').value}}</td>
                            <td>{{barsicRanksForm.get('vlowh').value}}</td>
                        </tr>
                        <tr>
                            <td>Medio Medio</td>
                            <td>{{barsicRanksForm.get('lowl').value}}</td>
                            <td>{{barsicRanksForm.get('lowh').value}}</td>
                        </tr>
                        <tr>
                            <td>Medio Superior</td>
                            <td>{{barsicRanksForm.get('midl').value}}</td>
                            <td>{{barsicRanksForm.get('midh').value}}</td>
                        </tr>
                        <tr>
                            <td>Superior</td>
                            <td>{{barsicRanksForm.get('highl').value}}</td>
                            <td>{{barsicRanksForm.get('highh').value}}</td>
                        </tr>
                        <tr>
                            <td>Excelente</td>
                            <td>{{barsicRanksForm.get('vhighl').value}}</td>
                            <td>{{barsicRanksForm.get('vhighh').value}}</td>
                        </tr>


                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<div class="card p-20">
    <h4>Secundaria</h4>
    <div class="row form-material">
        <div class="col-md-4 ">
            <div class="form-group">
                <label class="control-label">Factor</label>
                <select [(ngModel)]="selectedValue" class="form-control custom-select">
                    <option value="Muy inferior">Muy inferior</option>
                    <option value="Inferior">Inferior</option>
                    <option value="Mediano">Mediano</option>
                    <option value="Superior">Superior</option>
                    <option value="Excelente">Excelente</option>
                </select>
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label class="control-label">Intervalo inferior</label>

                <input type="number" [(ngModel)]="ranks.low" class="form-control" placeholder="Intervalo inferior">
            </div>
        </div>
        <div class="col-md-4">

            <div class="form-group">
                <label class="control-label">Intervalo superior</label>

                <input type="number" [(ngModel)]="ranks.high" class="form-control" placeholder="Intervalo superior">
            </div>
        </div>
    </div>
    <div>
        <button type="button" (click)="addRankSecondary()" class="btn btn-success waves-effect pull-right">Agregar/Reemplazar</button>
    </div>

</div>

<div class="col-12">
    <div class="card">
        <div class="card-body">
            <h4 class="card-title">Escolaridad: Nivel secundaria</h4>
            <div class="table-responsive">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Calificación</th>
                            <th>Bajo</th>
                            <th>Alto</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Muy inferior</td>
                            <td>{{barsicRanksSecondaryForm.get('vlowl').value}}</td>
                            <td>{{barsicRanksSecondaryForm.get('vlowh').value}}</td>
                        </tr>
                        <tr>
                            <td>Inferior</td>
                            <td>{{barsicRanksSecondaryForm.get('lowl').value}}</td>
                            <td>{{barsicRanksSecondaryForm.get('lowh').value}}</td>
                        </tr>
                        <tr>
                            <td>Mediano</td>
                            <td>{{barsicRanksSecondaryForm.get('midl').value}}</td>
                            <td>{{barsicRanksSecondaryForm.get('midh').value}}</td>
                        </tr>
                        <tr>
                            <td>Superior</td>
                            <td>{{barsicRanksSecondaryForm.get('highl').value}}</td>
                            <td>{{barsicRanksSecondaryForm.get('highh').value}}</td>
                        </tr>
                        <tr>
                            <td>Excelente</td>
                            <td>{{barsicRanksSecondaryForm.get('vhighl').value}}</td>
                            <td>{{barsicRanksSecondaryForm.get('vhighh').value}}</td>
                        </tr>


                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>


<div class="card p-20">
    <h4>Primaria</h4>
    <div class="row form-material">
        <div class="col-md-4 ">
            <div class="form-group">
                <label class="control-label">Factor</label>
                <select [(ngModel)]="selectedValue" class="form-control custom-select">
                    <option value="Muy inferior">Muy inferior</option>
                    <option value="Inferior">Inferior</option>
                    <option value="Mediano">Mediano</option>
                    <option value="Superior">Superior</option>
                    <option value="Excelente">Excelente</option>
                </select>
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label class="control-label">Intervalo inferior</label>

                <input type="number" [(ngModel)]="ranks.low" class="form-control" placeholder="Intervalo inferior">
            </div>
        </div>
        <div class="col-md-4">

            <div class="form-group">
                <label class="control-label">Intervalo superior</label>

                <input type="number" [(ngModel)]="ranks.high" class="form-control" placeholder="Intervalo superior">
            </div>
        </div>
    </div>
    <div>
        <button type="button" (click)="addRankPrimary()" class="btn btn-success waves-effect pull-right">Agregar/Reemplazar</button>
    </div>

</div>

<div class="col-12">
    <div class="card">
        <div class="card-body">
            <h4 class="card-title">Escolaridad: Nivel primaria</h4>
            <div class="table-responsive">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Calificación</th>
                            <th>Bajo</th>
                            <th>Alto</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Muy inferior</td>
                            <td>{{barsicRanksPrimaryForm.get('vlowl').value}}</td>
                            <td>{{barsicRanksPrimaryForm.get('vlowh').value}}</td>
                        </tr>
                        <tr>
                            <td>Inferior</td>
                            <td>{{barsicRanksPrimaryForm.get('lowl').value}}</td>
                            <td>{{barsicRanksPrimaryForm.get('lowh').value}}</td>
                        </tr>
                        <tr>
                            <td>Mediano</td>
                            <td>{{barsicRanksPrimaryForm.get('midl').value}}</td>
                            <td>{{barsicRanksPrimaryForm.get('midh').value}}</td>
                        </tr>
                        <tr>
                            <td>Superior</td>
                            <td>{{barsicRanksPrimaryForm.get('highl').value}}</td>
                            <td>{{barsicRanksPrimaryForm.get('highh').value}}</td>
                        </tr>
                        <tr>
                            <td>Excelente</td>
                            <td>{{barsicRanksPrimaryForm.get('vhighl').value}}</td>
                            <td>{{barsicRanksPrimaryForm.get('vhighh').value}}</td>
                        </tr>


                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>